/* @flow */
import React from "react";

import { Link } from "../common/Link";
import Gettext from "../common/Gettext";
import { Row, Input, Select, SelectColor, SelectWidth } from "../Popup";
import { InfoBlock } from "./ToolsContent";
import { COLORS } from "../Popup/SelectColor";
import { WIDTHS } from "../Popup/SelectWidth";

const ALGORITHMS = ["SMA", "EMA"];

export const initialState = {
  period: 13,
  algorithm: "SMA",
  color: COLORS[0],
  strokeWidth: WIDTHS[0]
};

export const indicatorTitle = <Gettext>Moving average</Gettext>;

export const Info = <InfoBlock>
  <Gettext>
    The indicator shows an average price of an asset for the time period. <Link to="/helpdesk/knowledge_base#kb_i">
      <Gettext>Learn more about the indicator.</Gettext>
    </Link>
  </Gettext>
</InfoBlock>;

const MovingAveragePopup = (props: Props) => (
  <Row>
    <Input
      label={<Gettext>Period</Gettext>}
      name="period"
      value={props.indicator.period}
      onChange={props.handleNumberChange}
      invalid={props.errors && props.errors.period}
    />
    <Select
      label={<Gettext>Type</Gettext>}
      name="algorithm"
      value={props.indicator.algorithm}
      values={ALGORITHMS}
      activeSelect={props.activeSelect}
      onClick={props.handleClick}
      onChange={props.handleAsIsChange}
    />
    <SelectColor
      label={<Gettext>Colour</Gettext>}
      name="color"
      value={props.indicator.color}
      activeSelect={props.activeSelect}
      onClick={props.handleClick}
      onChange={props.handleAsIsChange}
    />
    <SelectWidth
      label={<Gettext>Width of lines</Gettext>}
      name="strokeWidth"
      value={props.indicator.strokeWidth}
      activeSelect={props.activeSelect}
      onClick={props.handleClick}
      onChange={props.handleAsIsChange}
    />
  </Row>
);

export default MovingAveragePopup;



// WEBPACK FOOTER //
// ./src/components/Toolbar/MovingAveragePopup.js